import { useState, forwardRef, useImperativeHandle, useRef, useEffect, useContext, useMemo } from 'react';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import { MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons'
import QRCode from 'qrcode.react'
import { Spin, message, Select, Popover } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons'
import Utils from '@utils/utils'
import { AppContext } from '@utils/AppContext';
import API from '@api/api'
import eventBus from "@utils/eventBus";

const Tips = (props) => {
    const {
        unit,
        powerAmount
    } = props

    return (
        <ul className={styles.Tips}>
            <li>支付完成后默认您同意<a style={{ color: '#006EFF' }} target='_blank' href="/会员条款.htm">《PhotoStudio会员服务条款》</a> </li>
            <li>虚拟商品，支付后无法退款</li>
            <li>续购虹豆有效期与会员套餐有效期一致</li>
            <li>有效期内未用完的虹豆，如续订会员自动转入下一周期，如未续订则在有效期到期时清空</li>
        </ul>
    )
}

const AlipayQrcode = (props) => {
    const alipayFrameRef = useRef()

    useEffect(() => {
        alipayFrameRef.current.contentWindow.document.write(props.url)
    }, [props.url])

    return (
        <div className={styles.PayContent} key={props.url}>
            <div className={styles.iframePlaceholderWrap}>
                <Spin wrapperClassName={styles.iframePlaceholderSpin} spinning>
                    <div className={`${styles.iframePlaceholder} ${styles.alipay}`}></div>
                </Spin>
            </div>
            <iframe ref={alipayFrameRef}
                className={styles.payFrame}
                style={{ display: 'block' }}
                // srcDoc={payUrl}
                width="200"
                height="200"
                marginWidth={0}
                marginHeight={0}
                frameBorder="0"
                border="0"
                scrolling="no"
            ></iframe>
        </div>
    )
}

const WechatQrcode = (props) => {
    // weixin://wxpay/bizpayurl?pr=aYnckdQz3
    return (
        <div className={styles.PayContent} key={props.url}>
            <QRCode
                id="qrcode"
                value={props.url}
                size={200}
                level="H"
                style={{ margin: 'auto' }}
                imageSettings={{
                    src: require('@assets/images/icon_wxpay@2x.png'),
                    width: 50,
                    height: 50,
                    excavate: true,
                }}
            />
        </div>
    )
}


const DataSeatModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        open: () => setOpen(true),
        close: () => setOpen(false),
    }));
    const { globalUser } = useContext(AppContext);
    const [open, setOpen] = useState(false);
    const isMounted = useRef(true)
    const [loading, setLoading] = useState(false)
    const [channel, setChannel] = useState('alipay') // 支付渠道 alipay or wechat
    const [payUrl, setPayUrl] = useState() // 支付链接
    const [uPrice, setUPrice] = useState()
    const [diyMember, setDiyMember] = useState(1)
    const [dealAmount, setDealAmount] = useState()
    const [beanCount, setBeanCount] = useState(0)
    const [tradeId, setTradeId] = useState()
    const [unit, setUnit] = useState(globalUser?.membership?.level <= 4 ? 'Month' : 'Year')

    useEffect(() => {
        return () => isMounted.current = false
    }, [])

    const increaseBeanCount = () => {
        setBeanCount(prevCount => prevCount + 10000)
    }

    const decreaseBeanCount = () => {
        setBeanCount(prevCount => Math.max(0, prevCount - 10000))
    }

    const increaseDiyMember = () => {
        setDiyMember(prevCount => prevCount + 1)
    }

    const decreaseDiyMember = () => {
        setDiyMember(prevCount => Math.max(1, prevCount - 1))
    }

    const QRcoreContent = () => {
        return (
            <img className={styles.qrcodeSales} src={Utils.qrcodeSales} alt="扫码联系我们" />
        )
    }

    const getListPlan = () => {
        API.getListPlan({}).then((res) => {
            if (res.code == 0) {
                const subItem = res.data.filter(item => item.id == globalUser?.membership?.planId)
                if (subItem.length == 0) return
                setUPrice(Math.ceil(subItem[0]?.uPrice))
            }
        })
    }

    useEffect(() => {
        if (!open) return
        getListPlan()
    }, [open])


    const postSubscribePowerOrMember = () => {
        if (!beanCount && !diyMember) return
        API.postSubscribePowerOrMember({
            diyPower: beanCount,
            diyMember: diyMember,
            channel: channel,
        }).then(res => {
            if (res?.code != 0) throw new Error(res.message)
            setPayUrl(res.data?.payUrl)
            setTradeId(res.data?.tradeId)
            setDealAmount(Math.ceil(res.data?.dealAmount))
        }).catch(err => {
            message.error(err.message)
        })
    }




    const checkTradeStatus = (timerRef) => {
        API.paymentOrderStatus({ tradeList: [tradeId] }).then(res => {
            if (res.code != 0) return
            const item = res.data[0]
            if (item.status === 'success') {
                console.log('订单支付成功', item.tradeId)
                message.success('支付成功')
                eventBus.emit('updatePower')
                eventBus.emit('updateUserInfo')
                eventBus.emit('getUserOrgInfo')
                setOpen(false)
                return
            } else if (item.status === 'closed') {
                message.success('订单已关闭')
                setOpen(false)
                return
            } else {
                // 设置新的定时器
                timerRef.current = setTimeout(() => {
                    if (isMounted.current) checkTradeStatus(timerRef)
                }, 600)
            }
        })
    }

    useEffect(() => {
        if (!tradeId) return

        const timerRef = { current: null }
        checkTradeStatus(timerRef)

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current)
                timerRef.current = null
            }
        }
    }, [tradeId])


    useEffect(() => {
        if (!open) return
        postSubscribePowerOrMember()
    }, [open, beanCount, diyMember, channel])



    return <>
        <PSAIModal
            title={null}
            maxWidth={892}
            footer={null}
            open={open}
            maskClosable={false}
            okButtonProps={{ disabled: false, loading: false }}
            onCancel={() => setOpen(false)}
            onOk={() => setOpen(false)}
            zIndex={1002}
        >
            <div className={styles.DataPackageModal}>
                <div className={styles.DataPackageModalLeft}>
                    <p>增加席位</p>
                    <div className={styles.DataPackageModalLeftMiddle}>
                        <div>
                            <div className={styles.beanCount}>
                                <MinusCircleFilled
                                    className={styles.minusIcon}
                                    style={{ color: beanCount === 0 ? '#E3E9F0' : '#52A8FF' }}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={(e) => { e.stopPropagation(); decreaseBeanCount() }} />
                                <span className={styles.beanNum}>{beanCount / 10000}</span>
                                <PlusCircleFilled
                                    className={styles.plusIcon}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={(e) => { e.stopPropagation(); increaseBeanCount() }} />万虹豆
                            </div>
                            <div className={styles.beanTitle}>{uPrice * 10}元/万虹豆</div>
                            <div className={styles.beanTitle}>如仅新增席位可不选</div>

                        </div>
                        <div>
                            <div className={styles.beanCount}>
                                <MinusCircleFilled
                                    className={styles.minusIcon}
                                    style={{ color: diyMember === 1 ? '#E3E9F0' : '#52A8FF' }}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={(e) => { e.stopPropagation(); decreaseDiyMember() }} />
                                <span className={styles.beanNum}>{diyMember}</span>
                                <PlusCircleFilled
                                    className={styles.plusIcon}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={(e) => { e.stopPropagation(); increaseDiyMember() }} />
                            </div>
                            <div className={styles.beanTitle}>288元/席位</div>
                        </div>
                    </div>
                    <Tips
                        unit={unit}
                        isPowerPackage={false}
                        powerAmount={beanCount}
                    />
                </div>
                <div className={styles.DataPackageModalRight}>
                    <p className={styles.Head2}>请扫码支付 <span>{dealAmount}</span> 元</p>
                    <Spin spinning={false}>
                        <div className={styles.Content}>
                            <div className={styles.Qrcode}>
                                {
                                    payUrl &&
                                    <>
                                        {channel == 'alipay' && <AlipayQrcode key={payUrl} url={payUrl} />}
                                        {channel == 'wechat' && <WechatQrcode key={payUrl} url={payUrl} />}
                                    </>
                                }
                            </div>
                            <div className={styles.ChannelBtn}>
                                <div
                                    className={channel == 'alipay' ? styles.Active : ''}
                                    onClick={() => setChannel('alipay')}>
                                    <img src={require('@assets/images/icon_alipay.png')} />支付宝</div>
                                <div
                                    className={channel == 'wechat' ? styles.Active : ''}
                                    onClick={() => setChannel('wechat')}>
                                    <img src={require('@assets/images/icon_wxpay.png')} />微信</div>
                            </div>
                            <div className={styles.bottomQrcode}>
                                <Popover placement="bottom" content={QRcoreContent}>
                                    添加客服可开发票 <InfoCircleOutlined className={styles.infoIcon} />
                                </Popover>
                            </div>
                        </div>
                    </Spin>
                </div>
            </div>
        </PSAIModal>
    </>
})
export default DataSeatModal
